/* 9ffff1786ed5de9cae5eb0c872439da07e43ec4e
 * This file is automatically generated by graphql-let. */

import * as Types from '../../__types__';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ServerCurrentAtQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ServerCurrentAtQuery = { __typename?: 'Query', serverCurrentAt: string };


export const ServerCurrentAtDocument = gql`
    query ServerCurrentAt {
  serverCurrentAt
}
    `;

/**
 * __useServerCurrentAtQuery__
 *
 * To run a query within a React component, call `useServerCurrentAtQuery` and pass it any options that fit your needs.
 * When your component renders, `useServerCurrentAtQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServerCurrentAtQuery({
 *   variables: {
 *   },
 * });
 */
export function useServerCurrentAtQuery(baseOptions?: Apollo.QueryHookOptions<ServerCurrentAtQuery, ServerCurrentAtQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ServerCurrentAtQuery, ServerCurrentAtQueryVariables>(ServerCurrentAtDocument, options);
      }
export function useServerCurrentAtLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ServerCurrentAtQuery, ServerCurrentAtQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ServerCurrentAtQuery, ServerCurrentAtQueryVariables>(ServerCurrentAtDocument, options);
        }
export type ServerCurrentAtQueryHookResult = ReturnType<typeof useServerCurrentAtQuery>;
export type ServerCurrentAtLazyQueryHookResult = ReturnType<typeof useServerCurrentAtLazyQuery>;
export type ServerCurrentAtQueryResult = Apollo.QueryResult<ServerCurrentAtQuery, ServerCurrentAtQueryVariables>;